module.exports = __webpack_public_path__ + "img/g91.475ca0ff.svg";